import React from "react";
import s from "./TooltipIndicator.pcss";

export default props => (
    // need to pass the props on here since that is how OverlayTrigger controls showing tooltips
    <span className={s.container} {...props}>
        <span className={s.indicator}>i</span>
    </span>
);
